import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ThermometerSun, Lock, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.access_token, data.user);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center px-6">
      <Seo title="Admin-Login | Wärmekraft" description="" path="/admin/login" noindex />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-white text-sm mb-8 transition-colors" data-testid="back-home">
          <ArrowLeft className="h-4 w-4" /> Zur Startseite
        </Link>
        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-2xl">
          <div className="flex items-center gap-2 mb-2">
            <img src="/waermekraft-logo.png" alt="Wärmekraft" className="h-10 w-auto" />
          </div>
          <h1 className="font-display font-bold text-2xl text-forest mt-4">Admin-Login</h1>
          <p className="text-sm text-[#9AA0AC] mt-1">Verwalten Sie Ihre eingehenden Leads.</p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <Label htmlFor="email" className="text-sm font-semibold text-forest">E-Mail</Label>
              <Input id="email" type="email" data-testid="login-email" className="mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm font-semibold text-forest">Passwort</Label>
              <Input id="password" type="password" data-testid="login-password" className="mt-1.5" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {error && (
              <p className="text-sm text-red-600 bg-red-50 rounded-lg px-3 py-2" data-testid="login-error">{error}</p>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-btn"
              className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-forest px-6 py-3.5 text-sm font-bold text-white hover:bg-brand transition-colors disabled:opacity-60"
            >
              <Lock className="h-4 w-4" /> {loading ? "Anmeldung..." : "Anmelden"}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
}
